import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration, useBreakpointDown } from '@travel-frontend/core';
import { Trans, useTranslation } from 'next-i18next';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { FieldWrapper } from '../../../../components/Newsletter/SubscriptionBox/components/FieldWrapper.js';
import { isSubscriptionPending } from '../../../../components/Newsletter/SubscriptionBox/redux/reducer.js';
import { useValidation, useValidationError, useValidationErrorEvaluate } from '../../../../hooks/index.js';
import { Button, Checkbox, InsetTrigger, LabelXSmall, Link, Stack, TextField } from '../../../../primitives/index.js';
export const Form = ({
  small = false,
  onSubmit
}) => {
  const isPending = useSelector(isSubscriptionPending);
  const {
    t
  } = useTranslation();
  const smDown = useBreakpointDown('sm');
  const {
    domain,
    origin
  } = useConfiguration(['domain', 'origin']);
  const unsubscribeEmailAddress = `abmeldung@${domain}`;
  const [formData, setFormData] = useState({
    email: '',
    consent: false
  });
  const [insetExpanded, setInsetExpanded] = useState(false);
  const validationConfig = [{
    name: 'email',
    valid: value => /^\S[^\s@]*@\S[^\s.]*\.\S+$/.test(value)
  }, {
    name: 'consent',
    valid: value => value === true
  }];
  const {
    validate
  } = useValidation(validationConfig);
  const {
    errors,
    setErrors,
    setFieldErrors
  } = useValidationError([]);
  const {
    isFieldValid
  } = useValidationErrorEvaluate(errors);
  const transformFormData = formData => Object.entries(formData).map(([key, value]) => ({
    field: key,
    value
  }));
  const handleInsetExpand = e => {
    e.preventDefault();
    setInsetExpanded(previous => !previous);
  };
  const handleFocus = useCallback(() => setFieldErrors([], 'email'), [setFieldErrors]);
  const handleChange = useCallback(event => {
    const extractFieldValue = {
      email: ({
        value
      }) => value,
      consent: ({
        checked
      }) => checked
    };
    const name = event.currentTarget.name;
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const value = extractFieldValue[name](event.target);
    const errors = validate([{
      field: name,
      value
    }]);
    setFieldErrors(errors, name);
    setFormData(previous => ({
      ...previous,
      [name]: value
    }));
  }, [setFieldErrors, validate]);
  const handleSubmit = useCallback(() => {
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ field: string; value: unknown;... Remove this comment to see the full error message
    const errors = validate(transformFormData(formData));
    if (errors.length === 0) {
      onSubmit(formData.email);
    } else {
      setErrors(errors);
    }
  }, [formData, validate, onSubmit, setErrors]);
  const textField = _jsx(TextField
  // @ts-expect-error TS(2322) FIXME: Type '"medium" | "compact"' is not assignable to t... Remove this comment to see the full error message
  , {
    // @ts-expect-error TS(2322) FIXME: Type '"medium" | "compact"' is not assignable to t... Remove this comment to see the full error message
    size: smDown ? 'compact' : 'medium',
    name: "email",
    placeholder: smDown ? undefined : t('newsletterBox:form.hint'),
    label: t('newsletterBox:form.label'),
    onBlur: handleChange,
    onFocus: handleFocus,
    invalid: !isFieldValid('email'),
    message: isFieldValid('email') ? undefined : t('newsletterBox:form.validation.email')
  });
  return _jsxs(FieldWrapper, {
    small: small,
    children: [textField, _jsx(Button, {
      onClick: handleSubmit,
      disabled: isPending,
      fullWidth: smDown || small,
      children: t('newsletterBox:form.subscribe')
    }), _jsx(Checkbox, {
      multiline: true,
      name: "consent",
      onChange: handleChange,
      invalid: !isFieldValid('consent'),
      checked: formData.consent,
      label: _jsx(Stack, {
        children: _jsx(Trans, {
          i18nKey: insetExpanded ? 'newsletterBox:form.consentInsetShown' : 'newsletterBox:form.consentInsetHidden',
          components: {
            para: _jsx(LabelXSmall, {}),
            insetTrigger: _jsx(InsetTrigger, {
              onClick: handleInsetExpand
            }),
            email: _jsx(Link, {
              href: `mailto:${unsubscribeEmailAddress}`
            }),
            terms: _jsx(Link, {
              href: `${origin}/service/datenschutz`
            }),
            newsletterTerms: _jsx(Link, {
              href: `${origin}/service/datenschutz#newsletter`
            })
          },
          values: {
            unsubscribeEmailAddress,
            portalName: domain
          }
        })
      }),
      message: isFieldValid('consent') ? undefined : t('newsletterBox:form.validation.consent')
    })]
  });
};